import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
	selector: 'user-toggle-status',
	templateUrl: './user-toggle-status.component.html',
	styleUrls: ['./user-toggle-status.component.scss'],
})
export class UserToggleStatusComponent implements OnInit {
	@Input() isUserVisible = false;
	@Output() onChangeStatus = new EventEmitter();
	isToggleModalOpen = false;
	toggleModel = false;

	ngOnInit(): void {
		this.toggleModel = this.isUserVisible;
	}

	onToggle() {
		if (!this.modalPreference && this.toggleModel) {
			this.isToggleModalOpen = true;
			return;
		}
		this.onChangeStatus.emit(this.toggleModel);
	}

	get modalPreference() {
		return localStorage.getItem('statusModalPreference') === 'true';
	}
}
